import styled from 'styled-components';
import { SIDEBAR_MOBILE_BREAKPOINT } from '@constants/sidebar';
import {
  DOCK_WIDTH_COLLAPSED,
  DOCK_WIDTH_OPEN,
} from './editor/dock/ProcessSidePanel.styled';
import { ASSISTANT_RAIL_WIDTH } from './editor/assistant/processAssistant.constants';

export const PageRoot = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-height: 0;
  /* Editor chrome (topbar, banners, canvas, fixed dock) all live inside
     here. overflow: hidden ensures none of them — most importantly the
     bottom canvas toolbar pinned at bottom 16px of CanvasArea — can
     ever spill outside the page slot if a child briefly exceeds its
     budget (banner stack, side-panel, etc). */
  overflow: hidden;
`;

export const CanvasArea = styled.div<{
  $dockCollapsed?: boolean;
  /** Width the assistant panel occupies to the left of the dock, 0 when absent. */
  $assistantWidth?: number;
}>`
  flex: 1;
  min-height: 0;
  position: relative;
  margin-right: ${({ $dockCollapsed, $assistantWidth = 0 }) =>
    ($dockCollapsed ? DOCK_WIDTH_COLLAPSED : DOCK_WIDTH_OPEN) +
    $assistantWidth}px;
  transition: margin-right 280ms cubic-bezier(0.2, 0, 0, 1);

  /* On phones the open dock and assistant overlay the canvas, so only their rails take room. */
  @media (max-width: ${SIDEBAR_MOBILE_BREAKPOINT}px) {
    margin-right: ${({ $assistantWidth = 0 }) =>
      DOCK_WIDTH_COLLAPSED + ($assistantWidth ? ASSISTANT_RAIL_WIDTH : 0)}px;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${({ theme: { colors = {} } }) =>
    colors.onSurfaceVariant ?? '#C7C4D7'};
  font-size: 14px;
`;
